import {
    Directive,
    EventEmitter,
    HostListener,
    Input,
    Output
} from '@angular/core';

@Directive({
    selector: '[lib-debounce-click]',
    standalone: false
})
export class DebounceClickDirective {
    @Input() time = Date.now();

    @Output() debounceClick = new EventEmitter();

    constructor() {

    }


    @HostListener('click', ['$event'])
    @HostListener('touch', ['$event'])
    clickEvent(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if ((Date.now() - this.time) > (1 * 1000)) {
            this.debounceClick.emit(event)
        }
        this.time = Date.now();
    }
}
